/**
 * v-permission
 * 校验按钮权限
 * 接收参数：string[]
 */
import type { Directive, DirectiveBinding } from 'vue'
import { AuthStore } from '@/store/modules/auth'
interface ElType extends HTMLElement {
  copyData: string | number
  __handleClick__: any
}
const permission: Directive = {
  beforeMount(el: ElType, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: ElType, binding: DirectiveBinding) {
    checkPermission(el, binding)
  }
}

function checkPermission(el: ElType, binding: DirectiveBinding) {
  const { value } = binding
  const authStore = AuthStore()
  const permission = authStore.authButtons
  if (value && value instanceof Array) {
    if (value.length > 0) {
      const permissionRoles = value

      const hasPermission = permission.some(role => {
        return permissionRoles.includes(role) || permissionRoles.includes(false)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','editor']"`)
  }
}

export default permission
